import { render, staticRenderFns } from "./CostsDiscounts.vue?vue&type=template&id=6895f276"
import script from "./CostsDiscounts.vue?vue&type=script&lang=js"
export * from "./CostsDiscounts.vue?vue&type=script&lang=js"
import style0 from "./CostsDiscounts.vue?vue&type=style&index=0&id=6895f276&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports